<template>
  <div>
    <b-btn variant="link" @click="showModal">
      Merge Into...
    </b-btn>
    <c-modal
      v-model="modal"
      cancel-label="Cancel"
      centered
      no-close-on-esc
      no-close-on-backdrop
      title="Merge Into Another Tab"
      :tag="false"
      confirm-label="Proceed with Merge"
      :progressing="loading"
      size="lg"
    >
      <template>
        <div class="mb-3">
          Select the destination tab to merge Tab {{currentOrder.TabNo}} <span v-if="currentOrder.OrderTypeID === 2 && currentOrder.TableNumber">{{' - ' + currentOrder.TableNumber}}</span> into it.
        </div>
        <b-table-simple stacked="sm" class="mb-0" striped>
          <b-thead>
            <b-tr variant="bg-table">
              <b-th>Tab - Table No</b-th>
              <b-th>Type</b-th>
              <b-th>Status</b-th>
              <b-th>Pay</b-th>
              <b-th>Name</b-th>
              <b-th>Submited</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, key) in items" :key="key">
              <b-td>
                <span>{{item.TabNo}}</span>
                <span v-if="item.OrderTypeID === 2 && item.TableNumber">
                    {{' - ' + item.TableNumber}}
                </span>
              </b-td>
              <b-td>{{item.OrderType}}</b-td>
              <b-td>
                <span style="color:#f37021" class="font-weight-bold">
                  {{item.OrderStatus}}
                </span>
              </b-td>
              <b-td>{{item.PaymentStatus}}</b-td>
              <b-td>{{item.CustomerName}}</b-td>
              <b-td>{{validDate(item.OrderDate)}}</b-td>
              <b-td>
                <b-btn @click="selectTab(item)" size="sm" :variant="item.selected ? 'success' : 'secondary'">
                  <span>
                    {{item.selected ? 'Selected' : 'Select'}}
                  </span>
                </b-btn>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </template>
      <template #actions>
        <b-row class="flex-grow-1">
          <b-col cols="6">
            <b-btn variant="warning" block class="text-nowrap" :disabled="progressing || !isSelectTab" @click="merge">
              Proceed with Merge
              <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
            </b-btn>
          </b-col>

          <b-col cols="6">
            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="modal = false">
              Cancel
            </b-btn>
          </b-col>
        </b-row>
      </template>
    </c-modal>
  </div>
</template>

<script>
    import CModal from "./Cmodal";
    import moment from "moment";
    export default {
        name: "mergeTab",
        components: {CModal},
        props: {
            currentOrder: {
                required: true,
                type: Object
            },
            orders: {
                required: true,
                type: Array,
                default: () => []
            }
        },
        data () {
            return {
                modal: false,
                items: [],
                progressing: false
            }
        },
        computed: {
           isSelectTab () {
               return this.items.find(item => item.selected)
           }
        },
        methods: {
            validDate (date) {
                moment.locale('en-ca');
                return moment(date).format('D MMM YY - hh:mm A')
            },
            showModal () {
                this.items = this.orders.filter(item => item.OrderStatusID !== 5 && item.PaymentStatusID === 1 && item.OrderID !== this.currentOrder.OrderID)
                this.items.forEach(item => {
                    this.$set(item, 'selected', false)
                })
                this.modal = true
            },
            selectTab (item) {
                this.items.forEach(item => {
                    this.$set(item, 'selected', false)
                })
                item.selected = true
            },
            merge () {
                const tabNo = this.currentOrder.OrderTypeID === 2 && this.currentOrder.TableNumber
                    ? (this.currentOrder.TabNo + ' - ' + this.currentOrder.TableNumber)
                    : this.currentOrder.TabNo
                const message = `Note: This action will permanently delete Tab ${tabNo} and move its items to the destination tab selected.Do you want to proceed with merge?`
                this.$showConfirm(undefined, message).then(() => {
                  const model = {
                      // UserID: localStorage.getItem('userID'),
                      RestaurantID: this.$store.state.selectedRestaurantId,
                      OrderID: this.currentOrder.OrderID,
                      Destination_OrderID: this.isSelectTab.OrderID
                  }
                  this.progressing = true
                  return this.$api.getRestaurant.MergeRestaurantOrders(model).then(res => {
                      this.progressing = false
                      if (res.success) {
                          this.modal = false
                          this.$emit('refresh')
                      } else {
                          this.$showError(res.message)
                      }
                  }).catch(() => {
                      this.progressing = false
                  })
                })
            }
        }
    }
</script>

<style scoped>

</style>
